export default {
	getLatlngById(id, cb, ecb) {
		this.http
			.get('/area/getLatlngById/' + id, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getByZipCode(code, cb) {
		this.http.get('/area/getByZipCode/' + code, {}).then((res) => {
			cb(res)
		})
	},
	getNamesByZipCode(code, cb) {
		this.http.get('/area/getNamesByZipCode/' + code, {}).then((res) => {
			cb(res)
		})
	},
	getAll(level, cb) {
		this.http.get('/area/all/' + level, {}).then((res) => {
			cb(res)
		})
	}
}
